/* Kaddanse (16.10.2026, repris de Montrelio où il est éprouvé en ligne) — la galerie choisit la variante (W1, 26.09.2026, v2 après tests en émulation iPhone).
   Quand le client fait glisser la galerie ou touche une vignette et s'arrête sur la photo
   d'une variante, cette variante est sélectionnée (prix, bouton, pastilles suivent).
   Carte diapo → options : <script data-kdd-variant-media> rendu par
   snippets/product-media-gallery-content.liquid (null = photo qui n'est pas une variante).

   Principe : on lit la photo RÉELLEMENT affichée (position du défileur) quand la galerie
   s'arrête, au lieu de se fier aux événements du carrousel, qui manquent parfois juste
   après une reconstruction de la galerie.
   Deux correctifs du carrousel natif (slideshow.js) :
   1. après un changement de variante, la galerie reconstruite se replace souvent sur la
      photo 1 au lieu de la photo de la variante → replacement forcé (placeOn) ;
   2. l'index interne (vignette surlignée) peut rester en retard sur la photo affichée →
      réalignement à l'arrêt du défilement.
   Les défilements provoqués par le code (reconstruction, replacement, changement de
   variante) ne sélectionnent rien : fenêtre suppressUntil. */
(function () {
  if (window.__kddGalleryVariant) return;
  window.__kddGalleryVariant = true;

  var SETTLE_MS = 150;
  var settleTimer = null;
  var suppressUntil = Date.now() + 1500; /* chargement de la page */
  var busy = false; /* un changement de variante est en cours */
  var lastTouch = 0;      /* dernier contact du client avec la galerie */
  var lastChange = 0;     /* début du dernier changement de variante (pastille ou galerie) */
  var lastShown = -1;     /* dernière photo sur laquelle la galerie s'est arrêtée */

  /* Le geste du client est prioritaire sur tout replacement automatique. */
  function onTouch(e) {
    var t = e.target;
    if (t && t.closest && t.closest('slideshow-component[ref="slideshow"]')) lastTouch = Date.now();
  }
  document.addEventListener('touchstart', onTouch, { capture: true, passive: true });
  document.addEventListener('pointerdown', onTouch, { capture: true, passive: true });
  document.addEventListener('wheel', onTouch, { capture: true, passive: true });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-picker')) {
      lastChange = Date.now();
      showChosen(e.target);
    }
  }, true);

  function gallery() { return document.querySelector('slideshow-component[ref="slideshow"]'); }

  /* 03.10 — retour immédiat au clic sur une pastille : la galerie actuelle passe tout de
     suite sur la photo de la variante choisie, sans attendre que le thème recharge la
     galerie (sur réseau lent, l'ancienne photo restait affichée près d'une seconde). */
  function showChosen(input) {
    var picker = input.closest('variant-picker');
    var ss = gallery();
    if (!picker || !ss || !ss.refs || !ss.refs.scroller || !ss.refs.slides) return;
    var best = slideFor(picker, ss, input);
    if (best < 0 || shownIndex(ss) === best) return;
    placeOn(ss, best, Date.now());
  }

  /* Photo de la galerie qui correspond aux pastilles cochées (-1 si aucune). */
  function slideFor(picker, ss, input) {
    var map = readMap(ss.closest('.shopify-section') || document);
    if (!map) return -1;
    var chosen = {};
    picker.querySelectorAll('input[type="radio"]:checked').forEach(function (r) {
      if (r.dataset.optionName) chosen[r.dataset.optionName] = r.value;
    });
    picker.querySelectorAll('select').forEach(function (s) {
      var o = s.options[s.selectedIndex];
      if (o && o.dataset.optionName) chosen[o.dataset.optionName] = o.value;
    });
    var changedName = !input ? null : input.dataset.optionName || (input.options && input.options[input.selectedIndex] && input.options[input.selectedIndex].dataset.optionName);
    var best = -1, bestScore = -1;
    for (var n = 0; n < map.length; n++) {
      var t = map[n];
      if (!t || !t.length) continue;
      var score = 0, hasChanged = !changedName;
      for (var k = 0; k < t.length; k++) {
        if (chosen[t[k].n] === t[k].v) { score++; if (t[k].n === changedName) hasChanged = true; }
      }
      if (hasChanged && score > bestScore) { best = n; bestScore = score; }
    }
    return best;
  }

  function readMap(scope) {
    var el = scope.querySelector('[data-kdd-variant-media]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function slideWidth(ss) {
    var s = ss.refs && ss.refs.slides && ss.refs.slides[0];
    return s ? s.getBoundingClientRect().width || s.offsetWidth : 0;
  }

  function shownIndex(ss) {
    var sc = ss.refs && ss.refs.scroller;
    var w = slideWidth(ss);
    return sc && w ? Math.round(sc.scrollLeft / w) : -1;
  }

  /* Aligne l'index interne (et donc la vignette surlignée) sur la photo affichée. */
  function syncCurrent(ss, n) {
    if (n < 0 || ss.current === n || typeof ss.select !== 'function') return;
    suppressUntil = Math.max(suppressUntil, Date.now() + 400);
    ss.select(n, undefined, { animate: false });
  }

  /* Remet la galerie sur la photo n (index + position). */
  function placeOn(ss, n, born) {
    if (!ss.isConnected || !ss.refs) return;
    if (lastTouch > born) return; /* le client a repris la main sur la nouvelle galerie */
    var slides = ss.refs.slides, scroller = ss.refs.scroller;
    if (!slides || !scroller || !slides[n]) return;
    if (ss.current === n && shownIndex(ss) === n) return;
    suppressUntil = Math.max(suppressUntil, Date.now() + 900);
    if (ss.current !== n && typeof ss.select === 'function') ss.select(n, undefined, { animate: false });
    if (shownIndex(ss) !== n) scroller.scrollTo({ left: slides[n].offsetLeft - slides[0].offsetLeft, behavior: 'instant' });
  }

  /* Nouvelle galerie (chargement ou changement de variante) : on la tient sur sa photo
     initiale pendant sa première seconde de vie. */
  var knownGallery = null;
  function watchGallery() {
    var ss = gallery();
    if (!ss || ss === knownGallery) return;
    var first = knownGallery === null;
    knownGallery = ss;
    suppressUntil = Math.max(suppressUntil, Date.now() + 1200);
    var n = parseInt(ss.getAttribute('initial-slide') || '0', 10) || 0;
    /* Le client a glissé pendant le rechargement : on garde la photo qu'il regardait. */
    if (!first && lastTouch > lastChange && lastShown >= 0) n = lastShown;
    /* 03.10 — clics rapprochés : la galerie reconstruite peut venir de la réponse d'un clic
       PRÉCÉDENT ; on la cale sur les pastilles réellement cochées, pas sur cette réponse. */
    else if (!first) {
      var pk = (ss.closest('.shopify-section') || document).querySelector('variant-picker') || document.querySelector('variant-picker');
      var want = pk ? slideFor(pk, ss, null) : -1;
      if (want >= 0) n = want;
    }
    if (first && !n) return;
    var born = Date.now();
    /* Placement immédiat : l'observateur s'exécute avant l'affichage, la nouvelle galerie
       apparaît donc directement sur la bonne photo (plus d'éclair sur la photo 1). */
    if (n) {
      var scroller = ss.querySelector('slideshow-slides');
      var slides = scroller && scroller.querySelectorAll('slideshow-slide');
      if (slides && slides[n]) {
        suppressUntil = Math.max(suppressUntil, Date.now() + 1200);
        scroller.scrollTo({ left: slides[n].offsetLeft - slides[0].offsetLeft, behavior: 'instant' });
      }
    }
    [80, 250, 500, 900].forEach(function (t) { setTimeout(function () { placeOn(ss, n, born); }, t); });
  }
  new MutationObserver(watchGallery).observe(document.documentElement, { childList: true, subtree: true });
  watchGallery();

  function cssValue(v) {
    return window.CSS && CSS.escape ? CSS.escape(v) : String(v).replace(/"/g, '\\"');
  }

  /* Change UNE option qui diffère ; renvoie true si un changement a été lancé. */
  function applyOne(scope, target) {
    var picker = scope.querySelector('variant-picker');
    if (!picker) return false;
    for (var i = 0; i < target.length; i++) {
      var name = cssValue(target[i].n);
      var value = cssValue(target[i].v);
      var radio = picker.querySelector('input[type="radio"][data-option-name="' + name + '"][value="' + value + '"]');
      if (radio) {
        if (!radio.checked) { radio.click(); return true; }
        continue;
      }
      var opt = picker.querySelector('option[data-option-name="' + name + '"][value="' + value + '"]');
      if (opt && !opt.selected) {
        var select = opt.closest('select');
        select.value = opt.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }
    return false;
  }

  /* Plusieurs options peuvent différer (ex. couleur + bracelet) : une à la fois, en
     laissant le thème recharger le sélecteur entre deux. */
  function applyAll(scope, target, tries) {
    suppressUntil = Math.max(suppressUntil, Date.now() + 1500);
    if (!applyOne(scope, target) || tries <= 0) { busy = false; return; }
    busy = true;
    setTimeout(function () {
      applyAll(scope.isConnected ? scope : document, target, tries - 1);
    }, 900);
  }

  function onSettled() {
    var ss = gallery();
    if (!ss) return;
    var n = shownIndex(ss);
    if (n < 0) return;
    lastShown = n;
    syncCurrent(ss, n);
    /* Pendant une fenêtre protégée, on ne tranche pas tout de suite : on revérifie à sa fin
       (la galerie aura été replacée ; si le client a bien glissé ailleurs, on suit). */
    if (busy || Date.now() < suppressUntil) {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(onSettled, Math.max(100, suppressUntil - Date.now() + 60));
      return;
    }
    /* 03.10 — la galerie ne choisit la variante QUE si le client l'a manipulée lui-même
       (glissé, vignette, molette) APRÈS son dernier choix de pastille, et récemment.
       Avant : les défilements provoqués par le thème (galerie reconstruite qui se recale
       sur la photo de la variante) passaient pour un geste et ré-imposaient la variante
       de la photo affichée → le clic sur une pastille était annulé (1er clic de chaque
       fiche, 15-17 clics sur 42 en clics rapprochés). */
    if (!(lastTouch > lastChange) || Date.now() - lastTouch > 4000) return;
    var scope = ss.closest('.shopify-section') || document;
    var map = readMap(scope);
    var target = map && map[n];
    if (!target || !target.length) return;
    applyAll(scope, target, 3);
  }

  /* Le défilement horizontal de la galerie ne remonte pas : écoute en phase de capture. */
  document.addEventListener('scroll', function (event) {
    var t = event.target;
    if (!t || t === document || !t.parentElement) return;
    var ss = t.parentElement.closest('slideshow-component[ref="slideshow"]');
    if (!ss || !ss.refs || ss.refs.scroller !== t) return;
    clearTimeout(settleTimer);
    settleTimer = setTimeout(onSettled, SETTLE_MS);
  }, true);
})();
